import styled from 'styled-components';

export const InnerPanelWrapper = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  margin: 10px;
  padding-right: 10px;
  > * {
    min-height: 1px;
  }
`;
